import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import PostHogManager from '@widgets/posthog-manager';
import SentryManager from '@widgets/sentry-manager';
import { authActions } from '@actions';
import { authService } from '@services';
import { RoutePath } from '@constants/routes';
import { setUserInLocalStorage } from '@helpers/auth';

const VerifyEmail = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();

    const verifyEmail = async () => {
        try {
            const user = await authService.verifyEmail(params.token);
            setUserInLocalStorage(user);
            PostHogManager.identify(user);
            SentryManager.setUser(user);
            dispatch(authActions.setUser(user));
            navigate(RoutePath.Home);
        } catch (_) {
            navigate(RoutePath.Login);
        }
    };

    useEffect(() => {
        verifyEmail();
    }, []);

    return <div />;
};

export default VerifyEmail;
